let signedOut = false;

/**
 * The HTML carried the signed-out first page, which the Worker only adds for
 * a visitor with no session cookie: this load began signed out.
 */
export function markBootedSignedOut(): void {
  signedOut = true;
}

/** True when this load began with no session cookie (see above). */
export function bootedSignedOut(): boolean {
  return signedOut;
}
